class CollectionDescription extends HTMLElement {
  MAX_LENGTH = 500;
  SHOW_MORE = true;
  constructor() {
    super();
    this.descriptionFull = this.innerHTML;

    if (this.getAttribute("show-more") === "false") {
      this.SHOW_MORE = false;
    }

    if (this.getAttribute("max-length")) {
      this.MAX_LENGTH = parseInt(this.getAttribute("max-length"));
    }

    // Always move full description to bottom container
    if (this.SHOW_MORE) {
      const bottomDescContainer = document.getElementById("full-description");
      if (bottomDescContainer) {
        bottomDescContainer.innerHTML = this.descriptionFull;
      }
    }

    // remove processing class
    this.classList.remove("processing");
  }
}

customElements.define("collection-description", CollectionDescription);
